module.exports = __webpack_public_path__ + "img/cross3yellow.3a3c92f9.png";